class ContactPopup {
    constructor(options={}) {
        this.el = document.querySelector('.contact-popup');
        this.closeButton = this.el && this.el.querySelector('.close-button');
        this.sessionStorage = this.getSessionStorage();

        this.addEventListeners();
    }

    addEventListeners() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.close.bind(this));
        }

        if (this.el) {
            window.addEventListener('resize', this.toggleShow.bind(this));
            window.addEventListener('scroll', this.toggleShow.bind(this));
        }
    }

    setSessionStorage(display=true) {
        const today = new Date();
        const object = {
            display: display,
            timestamp: today.setDate(today.getDate() + 1)
        };

        sessionStorage.setItem('contact-popup', JSON.stringify(object));
    }

    getSessionStorage() {
        if (!sessionStorage.getItem('contact-popup')) {
            this.setSessionStorage();
        }

        return JSON.parse(sessionStorage.getItem('contact-popup'));
    }

    toggleShow() {
        const percentageScrolled = window.pageYOffset * 100 / document.documentElement.scrollHeight;

        if (percentageScrolled > 25 && this.sessionStorage.display) {
            this.el.classList.add('show');
        }
        else {
            this.el.classList.remove('show');
        }
    }

    close() {
        this.setSessionStorage(false);

        this.el.style.display = 'none';
        this.sessionStorage = this.getSessionStorage();
    }

    init() {
        const today = new Date();
        const currentTime = today.getTime();

        // Reset session if timestamp is a passed time.
        if (this.sessionStorage.timestamp < currentTime) {
            this.setSessionStorage(true);
            this.sessionStorage = this.getSessionStorage();
        }
    }
}

export function contactPopupInit() {
    if (window.location.pathname !== '/contact-us/') {
        // Comment out since popup was removed
        // new ContactPopup().init();
    }
}



// WEBPACK FOOTER //
// ./src/js/contact-popup.js